import { APP_INITIALIZER, ApplicationConfig, ErrorHandler, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { environment } from '../environments/environment';
import { NgxsModule } from '@ngxs/store';
import { AppState } from './app.state';
import { ENVIRONMENT, WINDOW } from './common/services/injection-tokens';
import { GlobalErrorHandler } from './common/services/logger/global-error-handler';
import { StartupService, startupServiceFactory } from './common/services/startup.service';
import { AuthenticationService } from './common/services/authentications.service';
import { CoolHttpModule } from '@angular-cool/http';
import { CoolStorageModule } from '@angular-cool/storage';
import { CoolDialogsModule } from '@angular-cool/dialogs';
import { LoggerService } from './common/services/logger/logger.service';
import { UnauthenticatedInterceptor } from './common/services/http/unauthenticated.interceptor';
import { RedirectAfterService } from './common/routing/redirect-after.service';
import { RouteNavigationService } from './common/routing/route-navigation.service';
import { NgxsSelectSnapshotModule } from '@ngxs-labs/select-snapshot';
import { LoggedInRouteGuardLogic } from './common/routing/route-guards/logged-in.guard';
import { GlobalCacheConfig } from 'ts-cacheable';
import { MINUTE_IN_MILLISECONDS } from '../../../common/utils/date.utils';
import { UsersService } from './common/services/users.service';
import { ClientsService } from './common/services/clients.service';
import { SessionsService } from './common/services/sessions.service';
import { FeaturePermissionsRouteGuardLogic } from './common/routing/route-guards/feature-permissions.guard';
import { UnauthenticatedRouteGuardLogic } from './common/routing/route-guards/unauthenticated.guard';
import { PaymentService } from './common/services/payment.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { BaseUrlInterceptor } from './common/services/http/base-url.interceptor';


GlobalCacheConfig.maxCacheCount = 1000;
GlobalCacheConfig.maxAge = 5 * MINUTE_IN_MILLISECONDS;
GlobalCacheConfig.promiseImplementation = Promise;

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: ENVIRONMENT, useValue: environment },
    { provide: WINDOW, useValue: window },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: APP_INITIALIZER, useFactory: startupServiceFactory, deps: [StartupService], multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: BaseUrlInterceptor, multi: true },

    RouteNavigationService,
    LoggedInRouteGuardLogic,
    FeaturePermissionsRouteGuardLogic,
    RedirectAfterService,
    UnauthenticatedInterceptor,
    UnauthenticatedRouteGuardLogic,

    LoggerService,
    StartupService,
    AuthenticationService,
    PaymentService,

    UsersService,
    ClientsService,
    SessionsService,

    provideRouter(routes),
    provideAnimations(),

    importProvidersFrom(
      NgxsModule.forRoot([AppState], {
        developmentMode: !environment.production,
      }),
      NgxsSelectSnapshotModule.forRoot(),
      CoolHttpModule.forRoot(),
      CoolStorageModule.forRoot(),
      CoolDialogsModule.forRoot(),
    ),
  ],
};
